(() => {
  const initialize = (newsletter) => {
    const form = newsletter.element;
    const typeRadios = form.querySelectorAll('.newsletter__type-radio');

    if (!typeRadios) {
      return;
    }

    const getStyleType = (type) => (form.querySelector('.newsletter__type-radio:checked').value === type ? 'block' : 'none');

    const toggleType = () => {
      const value = form.querySelector('.newsletter__type-radio:checked').value;

      form.querySelector('.newsletter__input-item--email').style.display = getStyleType('email');
      form.querySelector('.newsletter__input-item--phone').style.display = getStyleType('phone');
      form.querySelector(`.newsletter__input--${value}`).focus();
    };

    typeRadios.forEach((typeRadio) => typeRadio.addEventListener('change', toggleType));
  };

  const newsletter = stp.setup('newsletter');

  newsletter.map(initialize);
})();
